export default __webpack_public_path__ + "static/media/header-enviroai-logo.d0d962f7.svg";